import { FC } from 'react';
import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './skeleton';
import { CmsComponentProps } from '@/types/cms';
import { parseJson } from '@/utils/parseJson';

const DynamicCountdown = dynamic(() => import('./countdown'), {
  ssr: false,
  /**使用简单的dom触发useLazyData */
  loading: () => <div className="w-full h-5" />
});

const Countdown: FC<CmsComponentProps> = ({ ...props }) => {
  const imageInfo: { width: number; height: number } = parseJson(props.properties.pcImageInfo);
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });
  const skeleton = (
    <Skeleton
      style={{
        aspectRatio: `${imageInfo?.width} / ${imageInfo.height}`
      }}
    />
  );
  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }
  return <DynamicCountdown skeleton={skeleton} {...props} />;
};

export default Countdown;
